module.exports = __webpack_public_path__ + "static/media/Sarabun-ExtraBold.4ce35744.ttf";